// https://api-uat.arya.ag/api/lead-contract-details/331

import { RestMethod } from "../../../_helpers/ApiConfig/RestMethod";
import FilterResponse from "../../../_helpers/FilterResponse";

import { customToastr } from "../../../_Pages/_webapp/arya2.0/CustomToastr";
const callApi = async (api, Method, data, directResponse = false) => {
  try {
    const response = await RestMethod[Method](api, data);
    if (directResponse) return response;
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return

    return api_response.data;
  } catch (error) {
    customToastr({
      text: "Something went wrong. Please try again later",
      type: "error",
    });
    console.log("error detected while fetching data from api");
    return null;
  }
};
const callApi2 = async (api, Method, data, returnAllData,showToast = true) => {
  try {
    const response = await RestMethod[Method](api, data);
    const api_response = FilterResponse(response,showToast); //If respone 200 to 299 Then return

    return returnAllData ? response?.data : api_response.data;
  } catch (error) {
    customToastr({
      text: "Something went wrong. Please try again later",
      type: "error",
    });
    console.log("error detected while fetching data from api");
    return null;
  }
};

export const aryaProStockWarehouse = async (urlParamString) => {
  return callApi(
    `/v2/user/warehouse/list${urlParamString ? urlParamString : ""}`,
    "GET"
  );
};

export const liveStream = async (data) => {
  return callApi(`/v2/warehouse/live/camera`, "POST", data);
};
export const getUrlsVideo = async (data) => {
  return callApi(`/v2/warehouse/camera/view`, "POST", data);
};

export const getMyCommodities = async (urlParamString) => {
  return callApi(
    `/v2/seller-by-id/${urlParamString ? urlParamString : ""}`,
    "GET"
  );
};
export const warehouseRanges = async (urlParamString) => {
  return callApi(
    `/v2/warehouse/filter/${urlParamString ? urlParamString : ""}`,
    "GET"
  );
};

export const aryaProBorrowerStock = async (urlParamString) => {
  return callApi(
    `/v2/arya-pro-and-borrower-stock${urlParamString ? urlParamString : ""}`,
    "GET"
  );
};
export const aryaProStockCommodities = async (urlParamString) => {
  return callApi(
    `/v4/user/commodity/list${urlParamString ? urlParamString : ""}`,
    "POST"
  );
};

export const aryaProfinSRList = async (urlParamString) => {
  return callApi(`/v2/user/commodity/user-sr-list`, "GET");
};

export const getCommodityDetail = async (urlParamString) => {
  return callApi(
    `/v2/user/commodity/detail${urlParamString ? urlParamString : ""}`,
    "GET"
  );
};

export const getCommodityDetail2 = async (urlParamString, data) => {
  return callApi(
    `/v4/user/commodity/detail${urlParamString ? urlParamString : ""}`,
    "POST",
    data
  );
};

export const getActiveLoansForCommodityDetails = async (payload) => {
  return callApi(`/v4/get-active-loan-list`, "POST", payload);
};

export const getWarehouseDetail = async (urlParamString) => {
  return callApi(
    `/v2/user/warehouse/${urlParamString ? urlParamString : ""}`,
    "GET"
  );
};
export const loanAmountCalculator = async (data) => {
  return callApi(`/v2/loan-amount-calculator`, "POST", data);
};

export const addLoanRequest = async (data) => {
  return callApi(`/v2/add-loan-request`, "POST", data);
};
export const sendOtp = async (data) => {
  return callApi(`/v2/send-otp`, "POST", data);
};
export const verifyOtp = async (data) => {
  return callApi(`/v2/verify-otp`, "POST", data);
};

export const AddStockTransfer = async (data) => {
  return callApi(`/v2/stock/transfer/add`, "POST", data);
};
export const VerifyPaymentInfo = async (data) => {
  return callApi(`/v2/verify-payment-info`, "POST", data);
};

export const transferRequestList = async (urlParamString) => {
  return callApi(`/v2/stock/transfer/request` + urlParamString, "GET");
};

export const punchPayment = async (data) => {
  return callApi(`/v2/punch-payment`, "POST", data, true);
};

export const punchPaymentList = async (urlParamString = "") => {
  return callApi(`/v2/punch-payment-list` + urlParamString, "GET");
};

export const punchPaymentCommodityList = async (urlParamString = "") => {
  return callApi(`/v2/punch-payment-commodity-list` + urlParamString, "GET");
};

export const transferRequestDetail = async (urlParamString) => {
  return callApi(`/v2/stock/transfer/detail/` + urlParamString, "GET");
};

export const stockTransferUpdate = async (data) => {
  return callApi(`/v2/stock/transfer/update`, "POST", data);
};

export const stockTransferDelete = async (data) => {
  return callApi(`/v2/stock/transfer/delete`, "POST", data);
};

export const getAutoSanctionLeadData = async (refType, params) => {
  return callApi2(
    `/v2/stp-auto-sanction?reference_type=${refType}${
      params ? "&referenceId=" + params : ""
    }`,
    "GET",
    {},
    true,
    false
  );
};
export const getPanDetailsApi = async () => {
  return callApi(`/v2/user/identity-detail`, "GET");
};

export const acceptAutoSanctionLead = async (data, refType) => {
  return callApi(
    `/v2/stp-auto-sanction-update?reference_type=${refType}`,
    "POST",
    data
  );
};
export const createSTPLeadAPI = async (data, refType) => {
  return callApi(`/v2/stp-create-lead?reference_type=${refType}`, "POST", data);
};
export const releaseStockPaymentConsent = async (data) => {
  return callApi(`/v2/dtr/stpvirtual/take-consent`, "POST", data);
};

export const getCommodityWarehouseArray = async (data) => {
  return callApi(`/v4/get-sc-comodity-warehouses`, "POST", data);
};

export const getLoanByCommodityId = async (data) => {
  return callApi(`/v4/get-tentativeLoan-by-commodityId`, "POST", data);
};

export const initiateDisbReq = async (data) => {
  return callApi(`/v4/initiate-disbursement-request`, "POST", data);
};